module.exports = __webpack_public_path__ + "static/assets/1633feca6efea4b0c1dfdc9f6c7cda7c.svg";